import { inject } from '@angular/core';
import { ResolveFn } from '@angular/router';
import { OcrPrimeStore } from '../store/ocr-prime.store';

export const platformDataResolver: ResolveFn<boolean> = () => {
  const store = inject(OcrPrimeStore);
  return store.loadAllPlatformData();
};
